import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { FormElement } from 'src/front/components/FormStyles';
import { TextInput } from '@code/innovance-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';

interface Props {
  formatter: (v: string) => string;
  formMethods: UseFormMethods<IdentityFormData>;
  max: number;
  min: number;
  onChangeHandler: (field: string) => (value: string) => void;
}
const IssueBy: FC<Props> = ({ formatter, formMethods, max, min, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();

  return (
    <FormElement>
      <Controller
        control={control}
        name="issuedBy"
        render={({ onChange, value }) => (
          <TextInput
            errorMessage={t(errors?.issuedBy?.message as string, {
              min,
            })}
            formatter={formatter}
            label={t('general_issuedBy_label')}
            maxLength={max}
            name="issuedBy"
            onChange={(val) => {
              onChange(val);
              onChangeHandler('issuedBy')(val);
            }}
            value={value}
            required
          />
        )}
      />
    </FormElement>
  );
};

export default IssueBy;
